import { ResourceOptions } from 'react-admin';
import { FaTasks } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './list';
export { default as create } from './mutations/Create';
export { default as edit } from './mutations/Edit';

export const name = Resources.activityTierBenefits;
export const icon = FaTasks;
export const options: ResourceOptions = {
  label: 'resource.activityTierBenefits',
};
